<template>
  <div>
    <img :src="src" alt="" />
  </div>
</template>
<script>
import axios from "@/http/axios";
export default {
  data() {
    return {
      src: "",
    };
  },
  created() {
    let o = this.$route.query;
    sessionStorage.setItem("token", o.token);
    axios.post("/user/getKycMedia", {}).then((res) => {
      this.src = res.data.selfiePhotoUrl;
    });
  },
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
}
</style>
